import { defineMessages } from 'react-intl';

export const calculateDensityMessages = defineMessages({
  calculateDensity: {
    defaultMessage: 'Calculate Density',
    id: 'vOec+s',
    description: 'Button to compute the commodity density from dimensions and weight',
  },
  commodityTitle: {
    defaultMessage: 'Commodity {number}',
    id: '52VqGa',
    description: 'Title for a commodity card within a handling unit',
  },
  densityModalTitle: {
    defaultMessage: 'Recommended Freight Class',
    id: 'JzI82O',
    description: 'Title of the recommended freight class modal',
  },
  densityModalDensity: {
    defaultMessage: 'Calculated density: {density} lb/ft³',
    id: 'Kht3lH',
    description: 'Displays the calculated handling unit density in the recommended freight class modal',
  },
  densityModalNoDensity: {
    defaultMessage: 'Could not calculate density. Check that dimensions and weight are entered.',
    id: 'Nl4FAh',
    description: 'Shown in the recommended freight class modal when density could not be calculated',
  },
  densityModalNoChange: {
    defaultMessage: 'no change',
    id: 'K+qm/z',
    description: 'Label shown next to a commodity row in the density modal when the recommended class matches the current class',
  },
  densityModalNoRecommendation: {
    defaultMessage: 'No recommendation available',
    id: 'KmJbjR',
    description: 'Shown under a commodity name in the density modal when no freight class recommendation is available',
  },
  densityModalEmptyClass: {
    defaultMessage: 'None',
    id: '5C4/jW',
    description: 'Shown as the current freight class when a commodity has no class set',
  },
  densityModalDisclaimer: {
    defaultMessage:
      'Note: this calculator should be used as a guide to estimate the density and/or freight class of the shipment based on dimensions and weight provided by you, although each carrier reserves the right to re-classify freight based on their respective Rules Tariffs or under other guidance of the NMFTA. You are responsible for the fees associated with the actual density and/or freight class as determined by the carrier.',
    id: '9zDT6X',
    description: 'Disclaimer in the density modal noting that carriers may re-classify freight and the seller owes the resulting fees',
  },
  densityModalClose: {
    defaultMessage: 'Close',
    id: 'jGp6ML',
    description: 'Button to close the recommended freight class modal',
  },
  densityModalApply: {
    defaultMessage: 'Apply All',
    id: 'OGa1dE',
    description: 'Button to apply the recommended freight classes to all commodities',
  },
  densityModalApplySelection: {
    defaultMessage: 'Apply Selection',
    id: 'o1vBwV',
    description: 'Button to apply the recommended freight class to only selected commodities',
  },
});
